import { TranslateKeyOptions } from './translate_key_options';
import { I18NManager } from './i18n_manager';

const manager = new I18NManager();

const createKeyOptions = (key) => new TranslateKeyOptions(key);
const init = (language, translations) => manager.init(language, translations);
const get = () => manager.instance;

const i18n = {
	init,
	get,
	createKeyOptions
}

export {
	i18n
}
